// client/src/utils/media.js
// Set per environment: .env.development points `npm start` at the local API
// (http://localhost:5000), and .env.production points `npm run build` at
// https://jamhobbies.shopnetx.com, where IIS's reverse-proxy rules (see
// client/public/web.config) forward /api requests to the Express API. If unset,
// requests fall back to relative paths on the site's own origin.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Uploaded product images are stored as paths relative to the API
// server (e.g. "/uploads/123.png"), while seed/demo data uses full external
// URLs (e.g. placehold.co). Only relative paths need the API host prefixed —
// otherwise the browser resolves them against the React dev server's own
// origin (port 3000), which is why uploaded images wouldn't load.
export const NO_PHOTO_URL = `${process.env.PUBLIC_URL || ''}/no-photo.svg`;

export const getImageUrl = (path) => {
  if (!path || path === NO_PHOTO_URL) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path}`;
};

// A product's photo, or a neutral placeholder when it doesn't have one yet.
export const getProductImageUrl = (path) => getImageUrl(path) || NO_PHOTO_URL;
